import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  subtitle: {
    color: theme.palette.grey[400],
    padding: '16px 16px 0',
  },
}))
